import { render, staticRenderFns } from "./editCollegeColumn.vue.js?vue&type=template&id=1e23ebc1&scoped=true!=!../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./editCollegeColumn.vue?vue&type=template&id=1e23ebc1&scoped=true"
import script from "./editCollegeColumn.vue.js?vue&type=script&lang=js!=!../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./editCollegeColumn.vue?vue&type=script&lang=js"
export * from "./editCollegeColumn.vue.js?vue&type=script&lang=js!=!../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./editCollegeColumn.vue?vue&type=script&lang=js"
import style0 from "./editCollegeColumn.vue.scss?vue&type=style&index=0&id=1e23ebc1&lang=scss&scoped=true!=!../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./editCollegeColumn.vue?vue&type=style&index=0&id=1e23ebc1&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e23ebc1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/web-hok_Mssh/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e23ebc1')) {
      api.createRecord('1e23ebc1', component.options)
    } else {
      api.reload('1e23ebc1', component.options)
    }
    module.hot.accept("./editCollegeColumn.vue.js?vue&type=template&id=1e23ebc1&scoped=true!=!../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./editCollegeColumn.vue?vue&type=template&id=1e23ebc1&scoped=true", function () {
      api.rerender('1e23ebc1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Modal/course/editCollegeColumn.vue"
export default component.exports